<template>
<div class="container">
        <el-button class="tool-btn" icon="fas fa-link" @click="togglePanel()">合併活動</el-button>
        <div v-if="showPanel" class="panel">
            <div class="content">
                <div class="desc">您可以選擇1個「指定購買」與「受眾購買」進行合併，作為同一波廣告活動規劃 :</div>
                <div class="checkbox-area">
                    <div class="check-unit" v-for="(item, index) in data" :key="index">
                        <span>
                            <el-checkbox :disabled="checkboxStateArr[index].disabled" @change="toggleCheckbox(index)" v-model="checkboxStateArr[index].checked">
                                <span :class="{'disabled-text':checkboxStateArr[index].disabled}"> {{item.compareData.resultName}}</span>
                                <span v-if="item.compareData.type==='direct'"><span class="direct-campaign-type">指定購買</span></span>
                                <span v-else-if="item.compareData.type==='speed'"><span class="speed-campaign-type">受眾購買</span></span>
                            </el-checkbox>
                        </span>
                    </div>
                </div>
                <el-input type="text" placeholder="合併後的名稱" v-model="newPlanName"></el-input>
                <div style="text-align: right; margin:10px auto;">
                    <el-button type="primary" @click.native="sendMergeConfig">確定</el-button>
                    <el-button @click.native="togglePanel(false)">取消</el-button>
                </div>
            </div>
        </div>
</div>
</template>

<script>
export default {
  name: 'Merge',
  // @Zone data is an array with element like this: { compareData: { resultName: 'a', type: 'speed' }, index: 10 }
  props: ['data'],
  data: function () {
    const checkboxStateArr = this.data.map((el, index) => ({ type: el.compareData.type, checked: false, disabled: false, index }))
    return {
      showPanel: false,
      checkboxStateArr,
      USER_SELECT_LIMIT: {
        speed: 1,
        direct: 1
      },
      userSelectCounter: {
        speed: 0,
        direct: 0
      },
      newPlanName: ''
    }
  },
  computed: {
  },
  watch: {
    data: {
      handler () {
        this.resetData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    resetData () {
      this.checkboxStateArr = this.data.map((el, index) => ({ type: el.compareData.type, checked: false, disabled: false, index }))
      this.userSelectCounter = { speed: 0, direct: 0 }
      this.newPlanName = ''
    },
    togglePanel (val) {
      if (val !== undefined) {
        this.showPanel = val
      } else {
        this.showPanel = !this.showPanel
      }
      this.resetData()
    },
    toggleCheckbox (index) {
      const currentCheckboxState = this.checkboxStateArr[index]
      const checkedType = currentCheckboxState.type
      if (currentCheckboxState.checked) {
        this.userSelectCounter[checkedType]++
        this.checkboxStateArr.map(el => {
          if (el.type === checkedType) {
            el.disabled = (this.userSelectCounter[checkedType] === this.USER_SELECT_LIMIT[checkedType] && el.index !== index)
          }
        })
      } else {
        this.userSelectCounter[checkedType]--
        this.checkboxStateArr.map(el => {
          if (el.type === checkedType) {
            el.disabled = false
          }
        })
      }
    },
    sendMergeConfig () {
      const chosenCompareUnitDataArr = this.checkboxStateArr
        .filter(el => el.checked)
        .map(el => this.data[el.index])

      if (chosenCompareUnitDataArr.length >= 2) {
        this.$emit('merge', { chosenCompareUnitDataArr, newPlanName: this.newPlanName })
      }
      this.togglePanel()
    }
  }
}
</script>

<style scoped>
.container{
    width: 145px;
    height: 40px;
    display: inline-block;
    text-align: center;
    position: relative;
    color: #4da1ff;
}

.panel{
    width:365px;
    margin-top:10px;
    position: absolute;
    float: left;
    z-index: 2000;
    box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
    background-color: #ffffff;
}
.content{
    width: 336px;
    font-size: 16px;
    font-weight: 600;
    color: #444444;
    margin: auto;
}
.desc{
    margin: 18px auto 10px;
}
.checkbox-area{
    margin: 24px auto 0;
}
.check-unit{
    height: 30px;
    margin: 18px auto;
    text-align: left;
}
.speed-campaign-type {
    font-size: 12px;
    line-height: 1.5em;
    padding: 4px 16px 3px;
    background: #000000;
    color: #ffffff;
    border-radius: 12px;
    margin-left: 16px;
}
.direct-campaign-type {
    font-size: 12px;
    line-height: 1.5em;
    padding: 4px 16px 3px;
    color: #4a4a4a;
    border: solid 1px #4a4a4a;
    border-radius: 12px;
    margin-left: 16px;
}
.el-input{
    width: 336px;
    height: 40px;
    border-radius: 4px;
    border: solid 1px #c6c6c6;
    background-color: #ffffff;
}
.disabled-text{
    color: #c6c6c6;
}
.tool-btn{
    border-color:#4da1ff;
    color:#4da1ff;
}
</style>
